/* eslint-disable import/prefer-default-export */
export function getAPIToken(): string {
  const jwt = localStorage.getItem('jwt');
  if (jwt) return jwt;
  return '';
}
